import EntityBaseRepository from '@/api/misc/EntityBaseRepository';
import { AxiosResponse } from 'axios';

export default class MagazineRepository extends EntityBaseRepository {

    public getLocationMagazines(locationId?: string): Promise<AxiosResponse> {
        // map param
        const json = {
            id_hotspot: locationId
        };
        const urlEncoded = new URLSearchParams();
        urlEncoded.append('f', 'magazinePublishedGetAllLastByHotspotId');
        urlEncoded.append('json', JSON.stringify(json));
        return this.axiosClient.post(this.endpointDefault, urlEncoded);
    }

    public getCategoriesByLocale(locale?: string): Promise<AxiosResponse> {
        const json = {
            locale: locale
        };
        const urlEncoded = new URLSearchParams();
        urlEncoded.append('f', 'magazineCategoryGetAllActiveByLocale');
        urlEncoded.append('json', JSON.stringify(json));
        return this.axiosClient.post(this.endpointDefault, urlEncoded);
    }

    public getMagazineThumbnail(payload: { publicationId: string, page: number }): Promise<AxiosResponse> {
        const urlEncoded = new URLSearchParams();
        urlEncoded.append('id_mag_pub', payload.publicationId);
        urlEncoded.append('page', payload.page.toString());
        urlEncoded.append('version', '5');
        return this.axiosClient.get(`${this.endpointThumbnail}?${urlEncoded}`, { responseType: 'blob' });
    }

    public getMagazinePage(payload: { publicationId: string, page: number }): Promise<AxiosResponse> {
        const urlEncoded = new URLSearchParams();
        urlEncoded.append('id_mag_pub', payload.publicationId);
        urlEncoded.append('page', payload.page.toString());
        return this.axiosClient.get(`${this.endpointPage}?${urlEncoded}`, { responseType: 'blob' });
    }
}
